import type { PosterGridData } from '@/content/types';

export default function PosterGrid(props: PosterGridData) {
  return (
    <section className="section-padding" style={{ textAlign: 'center' }}>
      {props.eyebrow && (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', borderRadius: 999, background: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 16 }}>
          ● {props.eyebrow}
        </div>
      )}
      <h2 className="h-section" style={{ maxWidth: 900, margin: '0 auto', padding: '0 16px' }}>{props.title}</h2>
      {props.body && <p style={{ marginTop: 16, color: 'var(--color-ink)', maxWidth: 720, margin: '16px auto 0', padding: '0 16px' }}>{props.body}</p>}
      {props.cta && (
        <a href={props.cta.href} className="btn-primary" style={{ marginTop: 32 }}>
          {props.cta.label} →
        </a>
      )}

      <div style={{ position: 'relative', maxWidth: 1200, margin: '40px auto 0', padding: '0 16px' }}>
        <img src={props.image.src} alt={props.image.alt} width={props.image.width} height={props.image.height} loading="lazy" decoding="async" style={{ width: '100%', height: 'auto', borderRadius: 16 }} />
        {props.overlays && (
          <>
            <div style={{
              position: 'absolute', top: '40%', left: '15%', transform: 'translate(-50%, -50%)',
              padding: '16px 24px', background: 'rgba(0,0,0,.4)', backdropFilter: 'blur(8px)',
              color: '#fff', borderRadius: 12, fontSize: 18, fontWeight: 600, fontStyle: 'italic',
              textAlign: 'center', maxWidth: 280,
            }}>
              {props.overlays.left}
            </div>
            <div style={{
              position: 'absolute', top: '60%', left: '70%', transform: 'translate(-50%, -50%)',
              padding: '16px 24px', background: 'rgba(0,0,0,.4)', backdropFilter: 'blur(8px)',
              color: '#fff', borderRadius: 12, fontSize: 18, fontWeight: 600, fontStyle: 'italic',
              textAlign: 'center', maxWidth: 280,
            }}>
              {props.overlays.right}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
